<mat-card class="filter settingHeader">
    <div class="name">
        Manage Room
    </div>
    <div class="quickAction">
        <mat-form-field  appearence="fill" >
            <mat-label>Search Room</mat-label>
            <input matInput type="text" >            
          </mat-form-field>
        <button mat-flat-button class="addRoom" color="primary" (click)="openCaseDetail()" > Add Room </button>
    </div>
</mat-card>

<div class="listingHolder">
    <table class="table">
        <tr>
            <th>Name</th>
            <th>Description</th>
            <th>Procedure associated</th>
            <th class="available" >Available</th>
            <th class="action" >Action</th>
        </tr>
        <tr>
            <td>F1-5</td>
            <td>Any description which can elaborate… </td>
            <td>Cardiothoracic, ECG, Gestro </td>
            <td>
                <mat-slide-toggle color="primary" [(ngModel)]="isChecked" ></mat-slide-toggle>
            </td>
            <td>
                <div class="btnAction">
                    <button mat-icon-button color="primary"  >
                        <mat-icon>create</mat-icon>
                    </button>
                    <button mat-icon-button color="primary"  >
                        <mat-icon>delete_outline</mat-icon>
                    </button>
                </div>
            </td>
        </tr>
    </table>
</div>

<app-add-room [ngClass]="{'open': showCaseDetail}"  (closeCaseDetail)=getCloseCaseDetail($event)  ></app-add-room>